import React, { useRef, useState, useEffect, MouseEvent } from 'react';
import { INavItem } from 'mod/store/nav/interface';
import { hasSubmenu, moduleId, track } from 'mod/store/nav/utils';
import { MENU_TYPE_ROOM } from 'mod/store/nav/constant';
import { NavBanner } from 'mod/store/nav/NavBanner';
import { Col, Row } from '@base/lib/ThemeGrid';
import { NavClassicList } from 'mod/store/nav/NavPC/NavClassicList';
import { getWindowHeight } from 'ava-util/dist/dom-window';
import { displayCtr } from 'base/utils/tracker';

type SubMenuProps = {
    lv1Item: INavItem;
    lv1Index: number;
    onClose: () => void;
    visible: boolean;
};

export const SubMenu: React.FC<SubMenuProps> = ({ lv1Item, lv1Index, onClose, visible }) => {
    const menuRef = useRef<HTMLDivElement>(null);
    const isEmpty = !hasSubmenu(lv1Item);

    useEffect(() => {
        const menu = menuRef.current as HTMLDivElement;
        if (visible && menu) {
            menu.style.maxHeight = `${getWindowHeight() - menu.getBoundingClientRect().top}px`;
        }
    }, [visible]);

    useEffect(() => {
        if (visible && !isEmpty) {
            track({
                action: 'impr',
                target: lv1Item,
                relTarget: lv1Item,
                position: lv1Index + 1,
            });
            displayCtr(moduleId);
        }
    }, [visible, lv1Item]);

    return isEmpty ? null : (
        <div ref={menuRef}>
            <div className={'g-submenu-in'}>
                {lv1Item.menuType === MENU_TYPE_ROOM ? (
                    <NavBanner
                        {...lv1Item.roomContent}
                        lv1Item={lv1Item}
                        lv1Index={lv1Index}
                        onClose={onClose}
                    />
                ) : (
                    <Row colsPerRow={2} gutter={32}>
                        <Col>
                            <NavClassicList
                                lv1Item={lv1Item}
                                lv1Index={lv1Index}
                                list={lv1Item.classicContent.list}
                                onClose={onClose}
                            />
                        </Col>

                        {lv1Item.classicContent.banner && (
                            <Col>
                                <NavBanner
                                    {...lv1Item.classicContent.banner}
                                    lv1Item={lv1Item}
                                    lv1Index={lv1Index}
                                    onClose={onClose}
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </div>
        </div>
    )
};
